import useColors from "../customHooks/useColors";
import BaseParagraph from "../baseComponents/baseParagraph";

const HotNotification = ({ text1 = null, text2 = null, onClick = () => {} }) => {
  const [currentColors] = useColors();
  
  
  const styles = {
    container: {
      backgroundColor: currentColors.octonary,
      textAlign: "center",
      cursor: "pointer",
    },
    text: {
      fontSize: "20px",
      color: currentColors.secondary,
    },
  };

  return (
    <div className="fade-in" onClick = {onClick} style={styles.container}>
      <BaseParagraph style={styles.text}>{text1}</BaseParagraph>
      <BaseParagraph style={styles.text}>{text2}</BaseParagraph>
    </div>
  );
};

export default HotNotification;
